import { Component, Input, input } from '@angular/core';

import { RatingType } from '../models/rating-type';

@Component({
    selector: 'lib-scorecard-rating',
    templateUrl: './scorecard-rating.component.html',
    styleUrls: ['./scorecard-rating.component.scss'],
    standalone: false
})
export class ScorecardRatingComponent {
  showLabel = input<boolean>(true);
  rating = input<RatingType>();

  ratingLevels = RatingType;

}
